/**
 * SEO Priority Sorting Utilities
 * 
 * Contains priority lists and sorting functions for countries and cities.
 * Used to sort frontend pages by SEO traffic potential while keeping
 * admin pages sorted alphabetically for usability.
 */

// Countries with highest relocation/expat search volume globally
export const priorityCountries = [
  "Spain",
  "Portugal",
  "Thailand",
  "United Arab Emirates",
  "Mexico",
  "Indonesia",
  "Italy",
  "Japan",
  "Germany",
  "Turkey",
  "Malaysia",
  "Vietnam",
  "Greece",
  "Netherlands",
  "Canada"
];

// Cities with highest global search traffic for relocation/digital nomad/expat queries
export const priorityCities = [
  "Dubai",
  "Bangkok",
  "Barcelona",
  "Lisbon",
  "Bali",
  "Tokyo",
  "Singapore",
  "Mexico City",
  "Berlin",
  "Madrid",
  "Valencia",
  "Kuala Lumpur",
  "Phuket",
  "Chiang Mai",
  "Da Nang",
  "Ho Chi Minh City",
  "Buenos Aires",
  "Medellin",
  "Istanbul",
  "Antalya",
  "Budapest",
  "Prague",
  "Vienna",
  "Rome",
  "Milan"
];

/**
 * Sort countries by SEO priority (for frontend/public pages)
 * Priority countries appear first in their priority order,
 * remaining countries sorted alphabetically
 */
export const sortCountriesBySEO = (countries) => {
  return [...countries].sort((a, b) => {
    const ai = priorityCountries.indexOf(a.name);
    const bi = priorityCountries.indexOf(b.name);

    if (ai === -1 && bi === -1) return a.name.localeCompare(b.name);
    if (ai === -1) return 1;
    if (bi === -1) return -1;
    return ai - bi;
  });
};

/**
 * Sort cities by SEO priority (for frontend/public pages)
 * Priority cities appear first in their priority order,
 * remaining cities sorted alphabetically
 */
export const sortCitiesBySEO = (cities) => {
  return [...cities].sort((a, b) => {
    const ai = priorityCities.indexOf(a.name);
    const bi = priorityCities.indexOf(b.name);

    if (ai === -1 && bi === -1) return a.name.localeCompare(b.name);
    if (ai === -1) return 1;
    if (bi === -1) return -1;
    return ai - bi;
  });
};

/**
 * Sort countries alphabetically (for admin pages)
 */
export const sortCountriesAlphabetically = (countries) => {
  return [...countries].sort((a, b) => a.name.localeCompare(b.name));
};

/**
 * Sort cities alphabetically (for admin pages)
 */
export const sortCitiesAlphabetically = (cities) => {
  return [...cities].sort((a, b) => a.name.localeCompare(b.name));
};
